
// src/web/components/google-calendar-page.jsx

import React from 'react'
import connect from '../../connects/google-calendar-page'
import RightSidePage from './right-side-page.jsx'
import BidirectionalInfiniteScroll from './bidirectional-infinite-scroll.jsx'
import {
  ListItem,
} from 'react-toolbox/lib/list'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import Tooltip from 'react-toolbox/lib/tooltip';
import Dropdown from 'react-toolbox/lib/dropdown'
import { GoogleLogin } from './google-signin-provider.jsx'
import { MicrosoftLogin } from './MicrosoftLogin.jsx'
import listTheme from 'react-toolbox/lib/list/theme.css'
import moment from 'moment'
import _ from 'lodash'
import config from '../../config'
import classnames from 'classnames'
import compactListTheme from './themes/compact-list.css'
import GoogleCalendarItem from '../../web/components/google-calendar-item'
import GoogleCalendarHeaderItem from '../../web/components/google-calendar-header-item'
import googleCalendarListTheme from './themes/google-calendar-list.css'
import Loading from './loading.jsx'
import Calendar from 'react-calendar'
import './themes/calendar.scss'
import i18next from '../../i18n'
import { PublicClientApplication } from '@azure/msal-browser';
import { track } from '../../helpers/analytics';
import AccessToken from '../../actions/outlook-access-token'

const TooltipIconButton = Tooltip(IconButton)

class GoogleCalendarPage extends React.Component {
  state = { date: new Date(), msalUser: ''}

  constructor(props) {
    super(props);
    this.msalClient = new PublicClientApplication(config.msal);
    this.rightAction = [<TooltipIconButton key={'update'} icon='update' tooltip={props.t('label:再読み込み')} onClick={this.reloadCalendar} />]
  }

	onGooglSigninSuccess = ()=> {
		this.props.fetchCalendars()
		this.props.updateUI({ gapiReady: true })
    track('onGooglSigninSuccess')
	}
  onMicrosoftSigninSuccess = (msalUser)=> {
		this.props.fetchOutlookCalendars()
		this.props.updateUI({ isOutlookReady: true, msalUser  })
    track('onMicrosoftSigninSuccess')
	}
  onChange = (date) => {
    this.setState({ date })
    this.props.updateUI({ date: moment(date).format('YYYY-MM-DD') })
    this.props.ui.gapiReady && this.props.fetchEvents(this.props, date)
    this.props.ui.isOutlookReady && this.props.fetchOutlookEvents(this.props, date)
  }
  toggleImportInfo = (checkedDate) => {
    this.props.updateUI({
      checkedDates: Object.assign({}, this.props.ui.checkedDates, {
       [checkedDate]: !this.props.ui.checkedDates[checkedDate]
      })
    })
  }
  toggleTimeImportInfo = (checkedDate) => {
    this.props.updateUI({
      checkedTimeDates: Object.assign({}, this.props.ui.checkedTimeDates, {
       [checkedDate]: !this.props.ui.checkedTimeDates[checkedDate]
      })
    })
  }
  copyCalendarEvents = (date,inDescription, inTime) => {
    this.props.copyCalendarEvents(this.props, date, inDescription, inTime)
  }
  reloadCalendar = () => {
    this.setState({ date: new Date() })
    this.props.updateUI({ date: moment().format('YYYY-MM-DD') })
    this.props.reloadEventsCalendar(this.props)
  }

  onOutlookLogout = () => {
    const logoutRequest = {
      account: this.msalClient.getAccountByUsername(this.state.msalUser),
    };
    this.msalClient.logoutPopup(logoutRequest).then((res) => {
      this.props.outlookLogout()
      this.rightAction && this.rightAction.shift()
    });
  }

  onChangeCalendar = (calendar) => {
		if (calendar == 'cancel') {
			this.props.ui.gapiReady && GoogleLogin.signOut()
      this.props.ui.isOutlookReady && this.onOutlookLogout()
			this.props.updateUI({ gapiReady: false, isOutlookReady: false })
			this.props.refreshEvents(this.props)
      this.rightAction && this.rightAction.shift()
		}
		else {
	    this.setState({ date: new Date() })
	    this.props.updateUI({ date: moment().format('YYYY-MM-DD') })
	    this.props.changeCalendar(this.props, calendar)
		}
  }

	componentDidUpdate(prevProps) {
		if (!prevProps.isFetchFailed && this.props.isFetchFailed) {
			GoogleLogin.signOut()
			this.props.updateUI({ gapiReady: false })
			this.props.refreshEvents(this.props)
		}
    if (!prevProps.isOutlookCalendarFetchFailed && this.props.isOutlookCalendarFetchFailed) {
			this.props.updateUI({ isOutlookReady: false })
		}
    if(!prevProps.ui.isOutlookReady && this.props.ui.isOutlookReady)
      this.rightAction.unshift(<TooltipIconButton key={'open_in_new'} icon='open_in_new' tooltip={this.props.t('label:Outlookカレンダーを開く')} href={'https://outlook.live.com/calendar/'} target='_blank' rel="noopener noreferrer" />)
    if(!prevProps.ui.gapiReady && this.props.ui.gapiReady)
      this.rightAction.unshift(<TooltipIconButton key={'open_in_new'} icon='open_in_new' tooltip={this.props.t('label:Googleカレンダーを開く')} href={'https://calendar.google.com/calendar/'} target='_blank' rel="noopener noreferrer" />)
	}
  render() {
    const {
      t,
      ui,
      isFetching,
      isFetchFailed,
      events,
      calendars,
      fetchCalendars,
      refreshEvents,
      fetchEvents,
      reloadEventsCalendar,
      updateUI,
      copyCalendarEvents,
      changeCalendar,
      hasAfter,
      hasBefore,
      loadCalendar,
      isOutlookFetching,
      isOutlookFetchFailed,
      isOutlookCalendarFetchFailed,
      outlookEvents,
      outlookCalendars
    } = this.props

    return (
      <RightSidePage title={t('label:カレンダー')}
        rightAction={this.rightAction}
        icon="event_available">
        {!ui.gapiReady && !ui.isOutlookReady && <GoogleLogin label={t('label:Googleカレンダーに接続')} onSuccess={this.onGooglSigninSuccess} />}
        {!isFetchFailed && ui.gapiReady && !ui.isOutlookReady && calendars &&
          <div style={{ margin: '0px 10px'}}>
            <Dropdown auto
                source={calendars
                  .map((cal)=> ({ value: cal.id, label: cal.name }))
                  .concat({ value: 'cancel', label: t('label:Googleカレンダーを解除') })
                }
                value={ui.calendar}
                onChange={this.onChangeCalendar} />
          </div>
        }
        {!isFetchFailed && ui.gapiReady &&
          <div style={{ overflow: 'scroll' ,height: 'calc(100vh - 160px - 64px)', padding: 5 }}>
            <Calendar
              className="react-calendar"
              locale={i18next.language}
              calendarType="US"
              onChange={this.onChange}
              value={this.state.date}
              prev2Label={null}
              next2Label={null}
            />
            {events && events[ui.calendar] &&
              <GoogleCalendarHeaderItem
                event={events[ui.calendar][ui.date]}
                selectDate={ui.date}
                checked={this.props.ui.checkedDates[ui.date]}
                checkedTime={!this.props.ui.checkedTimeDates[ui.date]}
                t={this.props.t}
                copyCalendarEvents={this.copyCalendarEvents}
                toggleImportInfo={this.toggleImportInfo}
                toggleTimeImportInfo={this.toggleTimeImportInfo} />}
              {events && events[ui.calendar] &&
              (typeof events[ui.calendar][ui.date] == 'undefined' && <div><Loading/></div> ||
              events && events[ui.calendar] && events[ui.calendar][ui.date].length > 0 &&
                _.map(events[ui.calendar][ui.date], (event)=>
                <GoogleCalendarItem
                  key={event.event_id}
                  event={event}
                  checked={this.props.ui.checkedDates[ui.date]}
                  checkedTime={!this.props.ui.checkedTimeDates[ui.date]}
                  t={this.props.t}/>) ||
                <ListItem theme={googleCalendarListTheme} ripple={false} caption={t('label:予定がありません')} />)}
          </div>
        }
        {(!ui.isOutlookReady && !ui.gapiReady) && <MicrosoftLogin label={t('label:Outlookカレンダーに接続')} msalClient={this.msalClient} isOutlookCalendarFetchFailed={isOutlookCalendarFetchFailed} onSuccess={this.onMicrosoftSigninSuccess} loadAccessToken={this.props.loadAccessToken} emitAlertMessage={this.props.emitAlertMessage}/> }
        {!isOutlookFetchFailed && ui.isOutlookReady && !ui.gapiReady && outlookCalendars &&
          <div style={{ margin: '0px 10px'}}>
            <Dropdown auto
                source={outlookCalendars
                  .map((cal)=> ({ value: cal.id, label: cal.name }))
                  .concat({ value: 'cancel', label: t('label:Outlookカレンダーを解除') })
                }
                value={ui.calendar}
                onChange={this.onChangeCalendar} />
          </div>
        }
        {!isOutlookFetchFailed && ui.isOutlookReady &&
          <div style={{ overflow: 'scroll' ,height: 'calc(100vh - 160px - 64px)', padding: 5 }}>
            <Calendar
              className="react-calendar"
              locale={i18next.language}
              calendarType="US"
              onChange={this.onChange}
              value={this.state.date}
              prev2Label={null}
              next2Label={null}
            />
            {outlookEvents && outlookEvents[ui.calendar] &&
              <GoogleCalendarHeaderItem
                event={outlookEvents[ui.calendar][ui.date]}
                selectDate={ui.date}
                checked={this.props.ui.checkedDates[ui.date]}
                checkedTime={!this.props.ui.checkedTimeDates[ui.date]}
                t={this.props.t}
                copyCalendarEvents={this.copyCalendarEvents}
                toggleImportInfo={this.toggleImportInfo}
                toggleTimeImportInfo={this.toggleTimeImportInfo} />}
              {outlookEvents && outlookEvents[ui.calendar] &&
              (typeof outlookEvents[ui.calendar][ui.date] == 'undefined' && <div><Loading/></div> ||
              outlookEvents && outlookEvents[ui.calendar] && outlookEvents[ui.calendar][ui.date].length > 0 &&
                _.map(outlookEvents[ui.calendar][ui.date], (event)=>
                <GoogleCalendarItem
                  key={event.event_id}
                  event={event}
                  checked={this.props.ui.checkedDates[ui.date]}
                  checkedTime={!this.props.ui.checkedTimeDates[ui.date]}
                  t={this.props.t}/>) ||
                <ListItem theme={googleCalendarListTheme} ripple={false} caption={t('label:予定がありません')} />)}
          </div>
        }
      </RightSidePage>
    )
  }
}

export const RawGoogleCalendarPage = GoogleCalendarPage
export default connect(GoogleCalendarPage)



// WEBPACK FOOTER //
// ./src/web/components/google-calendar-page.jsx